// export const API_URL = "http://localhost:3001"; // Development
export const API_URL = 'https://ims.susicateringmedan.com/api'; // Live
